import { getCountries, getCountryCallingCode } from 'libphonenumber-js'
import { COUNTRY_OPTIONS } from './countries'

export interface CallingCodeOption {
  callingCode: string
  country: string
  name: string
}

const nameByCountry = new Map(
  COUNTRY_OPTIONS.map((option) => [option.code, option.name])
)

// ISO alpha-2 country + its international calling code, alphabetised by name.
export const CALLING_CODE_OPTIONS: CallingCodeOption[] = getCountries()
  .map((country) => ({
    callingCode: getCountryCallingCode(country),
    country,
    name: nameByCountry.get(country) || country,
  }))
  .sort((a, b) => a.name.localeCompare(b.name))

export const CALLING_CODE_BY_COUNTRY = new Map(
  CALLING_CODE_OPTIONS.map((option) => [option.country, option.callingCode])
)
